import React from 'react';
import Tippy from '@tippyjs/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import icons from '../../constants/icons';

type HelpProps = {
  helpContent?: string | React.ReactNode;
  className?: string;
  size?: SizeProp;
};

const Help = ({ helpContent, size, className }: HelpProps) => {
  if (!helpContent) {
    return null;
  }

  return (
    <Tippy content={helpContent} interactive={true}>
      <FontAwesomeIcon icon={icons.INFO} className={className} size={size} />
    </Tippy>
  );
};

export default Help;
